export const NORMAL_PLAYBACK_RATE = 1;

export const PLAYBACK_RATES = [NORMAL_PLAYBACK_RATE, 1.5, 1.6, 1.7, 1.8, 2];

export const formatPlaybackRate = (rate: number, locale: string): string =>
  `${new Intl.NumberFormat(locale).format(rate)}×`;
